// OJO con los nombres de las variables de nivel superior: este archivo se
// ejecuta en el mismo ambito global que el resto de los scripts del tema.
// El 18/08 un "const meta" choco con una variable global de Fabric y el
// hero entero dejo de funcionar. Por eso todo lo nuevo va con prefijo cheij.

const carrosel = document.getElementById("cheijCarrusel");
const cheijHero = document.querySelector(".cheij-hero");
const cheijBarra = document.querySelector(".cheij-hero__bar");
const cheijMeta = document.querySelector(".cheij-hero__meta");
const items = Array.from(carrosel.querySelectorAll(".cheij-hero__item"));
const n = items.length;

// Los mismos datos se muestran en dos lugares: las columnas laterales del
// escritorio y la fila que aparece debajo del escenario en mobile. Por eso
// se seleccionan por atributo y no por id.
const titleEls = Array.from(document.querySelectorAll("[data-cheij-title]"));
const descEls = Array.from(document.querySelectorAll("[data-cheij-desc]"));
const indexEls = Array.from(document.querySelectorAll("[data-cheij-index]"));
const markSvgs = Array.from(document.querySelectorAll(".cheij-hero__mark svg"));
const hintEl = document.querySelector("[data-cheij-hint]");

const allTextEls = titleEls.concat(descEls);

// Proporcion del isotipo: alto / ancho. Sale del viewBox del SVG.
const CHEIJ_RATIO_ISOTIPO = 1.1857;

// =====================================
// ALTURA: el hero entra completo en la primera pantalla
// =====================================

function ajustarAltura() {
    if (!cheijHero) return;

    const arriba = cheijHero.getBoundingClientRect().top + window.scrollY;

    let abajo = 0;
    if (cheijBarra) abajo += cheijBarra.offsetHeight;
    if (cheijMeta && getComputedStyle(cheijMeta).display !== "none") abajo += cheijMeta.offsetHeight;

    const disponible = Math.max(320, window.innerHeight - arriba - abajo);
    const proporcionItem = window.innerWidth <= 768 ? 0.9 : 0.95;

    cheijHero.style.setProperty("--cheij-stage-h", Math.round(disponible) + "px");
    cheijHero.style.setProperty("--cheij-item-h", Math.round(disponible * proporcionItem) + "px");
}

// =====================================
// ISOTIPO: mismo alto que la caja de texto de la izquierda
// =====================================

// Devuelve la posicion vertical de la linea de base de un elemento de texto.
function cheijLineaBase(el) {
    const s = document.createElement("span");
    s.style.cssText = "display:inline-block;width:0;height:0;vertical-align:baseline";
    el.appendChild(s);
    const y = s.getBoundingClientRect().bottom;
    s.remove();
    return y;
}

// Cuanto sube la tinta de las mayusculas por encima de la linea de base.
let cheijLienzo = null;
function cheijAltoMayusculas(el) {
    if (!cheijLienzo) cheijLienzo = document.createElement("canvas").getContext("2d");
    const cs = getComputedStyle(el);
    cheijLienzo.font = `${cs.fontStyle} ${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
    const texto = el.textContent.trim() || "M";
    return cheijLienzo.measureText(texto).actualBoundingBoxAscent;
}

// El dibujo tiene que medir lo mismo que el bloque titulo + bajada: del
// techo de las mayusculas del titulo a la linea de base de la bajada.
function ajustarIsotipo() {
    const esMobile = window.innerWidth <= 768;

    const titulo = document.querySelector(
        esMobile ? ".cheij-hero__meta-left h2" : ".cheij-hero__side--left h2"
    );
    const bajada = document.querySelector(
        esMobile ? ".cheij-hero__meta-left p" : ".cheij-hero__side--left p"
    );
    const marca = document.querySelector(
        esMobile ? ".cheij-hero__mark--meta" : ".cheij-hero__side--right .cheij-hero__mark"
    );

    if (!titulo || !bajada || !marca) return;

    const baseBajada = cheijLineaBase(bajada);
    const techoTitulo = cheijLineaBase(titulo) - cheijAltoMayusculas(titulo);
    const alto = baseBajada - techoTitulo;

    // Si algo no se pudo medir (fuente sin cargar, bloque oculto), se deja
    // el ancho de respaldo del CSS en vez de romper el layout.
    if (!(alto > 8)) return;

    marca.style.width = (alto / CHEIJ_RATIO_ISOTIPO).toFixed(2) + "px";

    const svg = marca.querySelector("svg");
    if (!svg) return;

    if (esMobile) {
        // La fila alinea por abajo. Se corrige la diferencia entre el borde
        // inferior de la caja de la bajada y su linea de base real.
        marca.style.marginBottom = "0px";
        const sobra = bajada.getBoundingClientRect().bottom - baseBajada;
        marca.style.marginBottom = Math.max(0, sobra).toFixed(1) + "px";
    } else {
        const aside = document.querySelector(".cheij-hero__side--right");
        if (!aside) return;
        aside.style.transform = "translateY(-50%)";
        const delta = baseBajada - svg.getBoundingClientRect().bottom;
        aside.style.transform = `translateY(calc(-50% + ${delta.toFixed(1)}px))`;
    }
}

// =====================================
// CONFIG
// =====================================

let SPACING = 0;

const RADIUS_FACTOR = 0.72;

function computeSpacing() {
    const w = carrosel.clientWidth;
    SPACING = Math.max(220, Math.min(420, w * 0.26)) * RADIUS_FACTOR;
}

// =====================================
// ESTADO
// =====================================

let pos = 0;
let lastRounded = null;
let hintOff = false;

function roundSym(x) {
    return x < 0 ? -Math.round(-x) : Math.round(x);
}

function circularDiff(itemIndex, position) {
    let diff = itemIndex - position;
    diff = diff - n * roundSym(diff / n);
    return diff;
}

const TAU = Math.PI * 2;

function render() {
    items.forEach((item, i) => {
        const diff = i - pos;
        const angle = (diff / n) * TAU;

        const s = Math.sin(angle);
        const c = Math.cos(angle);

        const depth = (1 - c) / 2;

        const translateX = s * SPACING;
        const translateY = -18 * depth;
        const scale = 1 - 0.15 * depth;
        const opacity = 1 - 0.75 * depth;

        const zIndex = Math.round(50 + c * 49);

        item.style.transform =
            `translate(-50%, 0) translate(${translateX}px, ${translateY}px) scale(${scale})`;
        item.style.opacity = opacity;
        item.style.zIndex = zIndex;
    });

    // El isotipo gira en 3D junto con el carrusel: una vuelta entera del
    // carrusel = una vuelta entera de la marca. Es vector, no video.
    const rot = (pos / n) * 360;
    markSvgs.forEach(svg => {
        svg.style.setProperty("--cheij-mark-rot", rot.toFixed(2) + "deg");
    });

    const rounded = ((roundSym(pos) % n) + n) % n;
    if (rounded !== lastRounded) {
        lastRounded = rounded;
        updateSideText(rounded);
    }
}

function pad(num) {
    return num < 10 ? "0" + num : String(num);
}

function updateSideText(index) {
    const item = items[index];

    allTextEls.forEach(el => {
        el.style.transition = "opacity .15s ease";
        el.style.opacity = "0";
    });

    indexEls.forEach(el => {
        el.textContent = pad(index + 1);
    });

    setTimeout(() => {
        titleEls.forEach(el => { el.textContent = item.dataset.title; });
        descEls.forEach(el => { el.textContent = item.dataset.desc; });

        allTextEls.forEach(el => {
            el.style.opacity = "1";
        });

        // El titulo cambia de largo entre prendas, pero el alto de la caja
        // no; aun asi se recalcula por si cambia la fuente cargada.
        ajustarIsotipo();
    }, 150);
}

function apagarPista() {
    if (hintOff || !hintEl) return;
    hintOff = true;
    hintEl.hidden = true;
}

function setTransition(enabled) {
    const value = enabled
        ? "transform .5s cubic-bezier(.2,.8,.2,1), opacity .5s ease"
        : "none";

    items.forEach(item => {
        item.style.transition = value;
    });

    markSvgs.forEach(svg => {
        svg.style.transition = enabled
            ? "transform .5s cubic-bezier(.2,.8,.2,1)"
            : "none";
    });
}

function init() {
    ajustarAltura();
    ajustarIsotipo();
    computeSpacing();
    pos = 0;
    lastRounded = null;
    render();
    indexEls.forEach(el => { el.textContent = "01"; });
    setTimeout(apagarPista, 9000);
}

init();
window.addEventListener("load", init);

// Cuando termina de cargar la tipografia cambian las medidas del texto.
if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(ajustarIsotipo);
}

window.addEventListener("resize", () => {
    ajustarAltura();
    ajustarIsotipo();
    computeSpacing();
    render();
});

// =====================================
// DRAG - MOUSE
// =====================================

let isDown = false;
let startX = 0;
let startPos = 0;
let dragMoved = false; // true si hubo un arrastre real, para no confundirlo con un click
const DRAG_THRESHOLD = 6; // px minimos de movimiento para contar como arrastre

carrosel.addEventListener("mousedown", (e) => {
    isDown = true;
    dragMoved = false;
    carrosel.classList.add("dragging");
    setTransition(false);
    startX = e.pageX;
    startPos = pos;
    apagarPista();
});

window.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const deltaPx = e.pageX - startX;
    if (Math.abs(deltaPx) > DRAG_THRESHOLD) dragMoved = true;
    pos = startPos - deltaPx / SPACING;
    render();
});

window.addEventListener("mouseup", () => {
    if (!isDown) return;
    isDown = false;
    carrosel.classList.remove("dragging");
    settle();
});

// =====================================
// DRAG - TOUCH
// =====================================

carrosel.addEventListener("touchstart", (e) => {
    isDown = true;
    dragMoved = false;
    setTransition(false);
    startX = e.touches[0].pageX;
    startPos = pos;
    apagarPista();
}, { passive: true });

carrosel.addEventListener("touchmove", (e) => {
    if (!isDown) return;
    const deltaPx = e.touches[0].pageX - startX;
    if (Math.abs(deltaPx) > DRAG_THRESHOLD) dragMoved = true;
    pos = startPos - deltaPx / SPACING;
    render();
}, { passive: true });

carrosel.addEventListener("touchend", () => {
    if (!isDown) return;
    isDown = false;
    settle();
});

function settle() {
    const target = roundSym(pos);
    setTransition(true);
    pos = target;
    render();

    setTimeout(() => {
        pos = ((pos % n) + n) % n;
    }, 520);
}

// =====================================
// CLICK EN UN ITEM PARA CENTRARLO / NAVEGAR
// =====================================

items.forEach((item, i) => {
    item.addEventListener("click", (e) => {
        // si hubo un arrastre real, este "click" es un efecto secundario del
        // drag (mousedown y mouseup sobre el mismo elemento) -> lo ignoramos,
        // para no navegar/centrar cuando el usuario solo queria swipear.
        if (dragMoved) {
            e.preventDefault();
            dragMoved = false;
            return;
        }

        apagarPista();

        const diff = circularDiff(i, pos);

        if (Math.abs(diff) < 0.05) {
            const link = item.dataset.link;
            if (link) window.location.href = link;
            return;
        }

        setTransition(true);
        pos = pos + diff;
        render();
        setTimeout(() => {
            pos = ((pos % n) + n) % n;
        }, 520);
    });
});
